import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import sidemenucss from "../../css/sidemenu.module.css";
import commoncss from "../../css/common.module.css";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as DelIcon } from "../../../myfin_v2/assets/icons/delete_red.svg";
import DeletePopup from "../../elements/DeletePopup";
import SuccessPopup from "../../elements/SuccessPopup";
import MenuIcon from "../../assets/icons/Menu.png";

import { Spinner } from "react-bootstrap";

const PopulateFSSideMenu = ({
  menuItems,
  subMenu,
  title,
  titleClassName,
  subTitle,
  activeCat,
  setActiveCat,
  setSubMenuId,
  showNotesDetails,
  redirectNote,
  setRedirectNote,
  subMenuId,
  subgroupId,
  setSubGroupId,
  isLoading,
  resizable = false,
  onWidthChange,
  onDeleteSubGroup,
  onAddSubGroup,
  onEditSubGroup,
  onReorderSubGroup,
  showCashflowWorkings,
  setShowCashflowWorkings,
}) => {
  const dispatch = useDispatch();
  const routerHistory = useHistory();

  const [hoveredNoteId, setHoveredNoteId] = useState(null);
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [newNoteLabel, setNewNoteLabel] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editNoteLabel, setEditNoteLabel] = useState("");

  const [sidebarWidth, setSidebarWidth] = useState(230);
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartWidth = useRef(230);

  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleConfirmDelete = async () => {
    if (itemToDelete && onDeleteSubGroup) {
      const success = await onDeleteSubGroup(itemToDelete.category, itemToDelete.groupID);
      if (success) {
        setSuccessMessage("Deleted successfully");
        setShowSuccessPopup(true);
      }
    }
    setShowDeletePopup(false);
    setItemToDelete(null);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartWidth.current = sidebarWidth;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const dx = e.clientX - dragStartX.current;
    let newWidth = dragStartWidth.current + dx;
    if (newWidth < 200) newWidth = 200;
    if (newWidth > 600) newWidth = 600;
    setSidebarWidth(newWidth);
    if (onWidthChange) onWidthChange(newWidth);
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleSubMenuReorder = async (result) => {
    if (!result.destination || !onReorderSubGroup) return;

    const { source, destination } = result;
    if (source.index === destination.index) return;

    const category = subMenu?.category;
    if (!category || !["general notes", "disclosure"].includes(category)) return;

    await onReorderSubGroup(category, source.index, destination.index);
  };

  useEffect(() => {
    if (redirectNote && subMenu) {
      setSubMenuId(redirectNote);
      showNotesDetails(redirectNote);
      setRedirectNote(null);
    }
  }, [subMenu]);

  // Auto-scroll to active submenu item
  useEffect(() => {
    if (subMenuId) {
      const timer = setTimeout(() => {
        const el = document.getElementById("side-consol-" + subMenuId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [subMenuId]);

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
      style={resizable ? { width: `${sidebarWidth}px`, minWidth: `${sidebarWidth}px`, position: "relative", flexShrink: 0 } : {}}
    >
      {resizable && (
        <div
          onMouseDown={handleMouseDown}
          style={{
            position: "absolute",
            top: 0,
            right: -3,
            width: "6px",
            height: "100%",
            cursor: "col-resize",
            zIndex: 9999,
            backgroundColor: "transparent",
          }}
        />
      )}
      <div
        className={sidemenucss.sidemenuHeader}
        style={{ minHeight: "15vh" }}
      >
        <span className={`${sidemenucss.sidemenuTitle} ${titleClassName || ""}`}>{title}</span>
        <span className={`${sidemenucss.sidemenuSubTitle} ${sidemenucss.customSideMenu}`}>{subTitle}</span> 
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} ${commoncss.hideScroll} pt-0`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                className={`${sidemenucss.sidemenuItem} ${
                  activeCat === item.value ? sidemenucss.sidemenuItemActive : ""
                }`}
                onClick={() => {
                  if (typeof setShowCashflowWorkings === "function" && showCashflowWorkings) {
                    setShowCashflowWorkings(false);
                  }
                  setActiveCat(item.value);
                }}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                  </div>
                </span>
              </li>

              {/* Loader for sub-menu items */}
              {isLoading && activeCat === item.value && (
                <div className="d-flex justify-content-center p-2">
                  <Spinner animation="border" size="sm" variant="success" />
                </div>
              )}

              {subMenu &&
                subMenu?.category === item.value &&
                subMenu?.submenu && (
                  <div className={sidemenucss.submenuContainer}>
                    <DragDropContext onDragEnd={handleSubMenuReorder}>
                      <Droppable droppableId={`submenu-${item.value}`} type="SUBMENU_ITEM">
                        {(provided) => (
                          <div ref={provided.innerRef} {...provided.droppableProps}>
                            {subMenu.submenu.map((subItem, idx) => {
                              const isHovered = hoveredNoteId === subItem.value;
                              const isSelected = subMenuId === subItem.value;
                              const showIcons = isHovered || isSelected;
                              const isEditing = editingNoteId === subItem.value;
                              const isDisclosure = ["general notes", "disclosure"].includes(item.value);

                              return (
                                <Draggable
                                  key={subItem.value}
                                  draggableId={subItem.value}
                                  index={idx}
                                  isDragDisabled={!isDisclosure}
                                >
                                  {(dragProvided) => (
                                    <div
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                      id={"side-consol-" + subItem.value}
                                      className={`${sidemenucss.submenuItem} ${
                                        isSelected
                                          ? sidemenucss.activeSubMenu
                                          : ""
                                      }`}
                                      onClick={() => {
                                        showNotesDetails(subItem.value);
                                        setSubMenuId(subItem.value);
                                      }}
                                      onMouseEnter={() => setHoveredNoteId(subItem.value)}
                                      onMouseLeave={() => setHoveredNoteId(null)}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        position: "relative",
                                        paddingLeft: isDisclosure ? "18px" : undefined,
                                        ...dragProvided.draggableProps.style,
                                      }}
                                    >
                                      {isDisclosure && (
                                        <span
                                          {...dragProvided.dragHandleProps}
                                          style={{
                                            position: "absolute",
                                            left: 0,
                                            transform: "translate(-20%, 0)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "grab",
                                            opacity: showIcons ? 1 : 0,
                                            pointerEvents: showIcons ? "auto" : "none",
                                            transition: "opacity 0.18s ease",
                                          }}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <img src={MenuIcon} alt="drag" style={{ width: 8, height: 10 }} />
                                        </span>
                                      )}
                                      {isEditing ? (
                                        <input 
                                          type="text" 
                                          value={editNoteLabel} 
                                          onChange={(e) => setEditNoteLabel(e.target.value)} 
                                          autoFocus 
                                          onClick={(e) => e.stopPropagation()}
                                          onBlur={async () => {
                                            if (editNoteLabel.trim() !== "" && editNoteLabel !== subItem.label) {
                                              if (onEditSubGroup) {
                                                await onEditSubGroup(item.value, subItem.value, editNoteLabel);
                                              }
                                            }
                                            setEditingNoteId(null);
                                          }}
                                          onKeyDown={async (e) => {
                                            if (e.key === 'Enter') {
                                              if (item.value === "general notes") {
                                                e.preventDefault();
                                                e.currentTarget.blur();
                                              } else {
                                                if (editNoteLabel.trim() !== "" && editNoteLabel !== subItem.label) {
                                                  if (onEditSubGroup) {
                                                    await onEditSubGroup(item.value, subItem.value, editNoteLabel);
                                                  }
                                                }
                                                setEditingNoteId(null);
                                              }
                                            }
                                          }}
                                          style={{ flex: 1, marginRight: '10px', padding: '2px 5px', border: '1px solid #ccc', borderRadius: '4px' }}
                                        />
                                      ) : (
                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                          {subItem.label}
                                        </span>
                                      )}
                                      {isDisclosure && (
                                        <div style={{ display: "flex", gap: "8px", alignItems: "center", opacity: showIcons ? (isSelected ? 1 : 0.6) : 0, transition: "opacity 0.2s" }}>
                                          <EditIcon 
                                            style={{ width: "15px", height: "15px", cursor: "pointer" }} 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setEditingNoteId(subItem.value);
                                              setEditNoteLabel(subItem.label);
                                            }}
                                          />
                                          <DelIcon 
                                            style={{ width: "15px", height: "15px", cursor: "pointer" }} 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setItemToDelete({ category: item.value, groupID: subItem.value });
                                              setShowDeletePopup(true);
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>

                    {isAddingNote && ["general notes", "disclosure"].includes(item.value) && (
                      <div
                        className={sidemenucss.submenuItem}
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "5px" }}
                      >
                        <input 
                          type="text" 
                          value={newNoteLabel} 
                          onChange={(e) => setNewNoteLabel(e.target.value)} 
                          autoFocus 
                          placeholder="Type Note Name here"
                          onBlur={async () => {
                            if (newNoteLabel.trim() !== "") {
                              if (onAddSubGroup) {
                                await onAddSubGroup(item.value, newNoteLabel);
                              }
                            }
                            setIsAddingNote(false);
                            setNewNoteLabel("");
                          }}
                          onKeyDown={async (e) => {
                            if (e.key === 'Enter') {
                              if (item.value === "general notes") {
                                e.preventDefault();
                                e.currentTarget.blur();
                              } else {
                                if (newNoteLabel.trim() !== "") {
                                  if (onAddSubGroup) {
                                    await onAddSubGroup(item.value, newNoteLabel);
                                  }
                                }
                                setIsAddingNote(false);
                                setNewNoteLabel("");
                              }
                            }
                          }}
                          style={{ width: "100%", padding: '2px 5px', border: '1px solid #ccc', borderRadius: '4px' }}
                        />
                      </div>
                    )}

                    {["general notes", "disclosure"].includes(item.value) && (
                      <div
                        className={sidemenucss.submenuItem}
                        style={{ display: "flex", gap: "8px", alignItems: "center", cursor: "pointer", color: "#205a46", fontWeight: "600", marginTop: "10px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsAddingNote(true);
                        }}
                      >
                        <Plus style={{ width: "14px", height: "14px" }} />
                        <span>Add Note</span>
                      </div>
                    )}
                  </div>
                )}
            </div>
          ))}
        </ul>
      </div>

      <DeletePopup
        isOpen={showDeletePopup}
        onCancel={() => {
          setShowDeletePopup(false);
          setItemToDelete(null);
        }}
        onConfirm={handleConfirmDelete}
        message="Once deleted, you will not be able to recover this section!"
      />

      {showSuccessPopup && (
        <SuccessPopup
          isOpen={showSuccessPopup}
          message={successMessage}
          onClose={() => setShowSuccessPopup(false)}
        />
      )}
    </div>
  );
};

export default PopulateFSSideMenu;
